module.exports = __webpack_public_path__ + "img/jatri_wheel.d21380bf.svg";